import React from "react";
import PropTypes from "prop-types";
import { Checkbox, IconButton, styled } from "@mui/material";
import { allIcons } from "../../assets";

const StyledIconButton = styled(IconButton)({
  padding: 0,
  width: 20,
  height: 20,
  "&:hover": {
    backgroundColor: "transparent",
  },
});

const CustomCheckbox = ({ isChecked, handleChecked }) => {
  return (
    <StyledIconButton onClick={handleChecked}>
      <img
        src={
          isChecked ? allIcons.checkRectangeIcon : allIcons.uncheckRectangeIcon
        }
        alt={isChecked ? "Checked" : "Unchecked"}
        width={"100%"}
        height={"100%"}
      />
    </StyledIconButton>
  );
};

CustomCheckbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
};

export default React.memo(CustomCheckbox);
